module.exports = __webpack_public_path__ + "static/img/zgpa.930353a4.png";